import React from 'react';
import styled from 'styled-components';
import { setHeaderTransferAction, setCurMenuAction } from "../../modules/common/headerModule";
import { useHistory, Link } from "react-router-dom";
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import ProdThumbnail from '../../components/common/prod/ProdThumbnail';
import ProdDetailOption from '../../components/common/prod/ProdDetailOption';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { detailAction, setLocInfo } from '../../modules/pd/prodDetailModule';
import { setSelProdInfoAction } from '../../modules/common/prodModule';
import ProdDetailStickyOption from '../../components/common/prod/ProdDetailStickyOption';
import { useRef } from 'react';
import { Log } from '../../lib/util/CustomUtil';
import LoadingOverlay from 'react-loading-overlay';
import { prodAction, setClipProdIdAction } from '../../modules/su/userProdModule';
import { brandAction, setClipBrandIdAction } from '../../modules/su/userBrandModule';
import {isMobileOnly} from 'react-device-detect';
import { split } from 'lodash';
import ProdSpecs from '../../components/common/prod/ProdSpecs';
import {Waypoint} from 'react-waypoint';
import ProdDetailOptionWing from '../../components/common/prod/ProdDetailOptionWing';
import Slider from "react-slick";
import ProdItemSlider from '../../components/common/prod/ProdItemSlider';
import SlideBtn from '../../components/common/button/SlideBtn';
import { reqEsProdAction } from '../../modules/es/esItemModule';
import SlideBanner from '../../components/common/banner/SlideBanner';
import * as F from '../../lib/util/CommonFunctions';
import ProdDetailOption2 from '../../components/common/prod/ProdDetailOption2';
import BrBrandProdItem from '../../components/br/BrBrandProdItem'
import { Helmet } from 'react-helmet-async';

const ProdDetailBlock = styled.div`
  ${isMobileOnly&&"margin:0 4vw"};
  ${isMobileOnly&&"padding:0 0 100px 0"};
`;
const ProdDetailContainerBlock = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: ${isMobileOnly?"60px 0 0":"auto"};
    // padding: 100px 0 ${isMobileOnly?"10px":"120px"};
    padding: ${isMobileOnly?"0":"100px 0 0"};

`;

const ProdDetailBottomContainerBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    max-width: 1176px;
    `:`
    width: 100%;
    width: 1176px;  
    `}

    margin: ${isMobileOnly?"0 0 0 0":"auto"};
    // padding: 100px 0 ${isMobileOnly?"10px":"120px"};

    .left-container {
        width: 800px;
    }

    .right-container {
        width: 376px;
        position: relative;
    }

    .wing-conatiner {
        position: absolute;
        left : 0;
    }

    ${isMobileOnly?`
        .default-table  {
            .dt-title {font-size: 16px; &.pad-b10 {padding-bottom:10px;}}
            .product_pay {font-size: 16px;}            
        }
     `:`
        .default-table  {
            .dt-title {font-size: 18px; &.pad-b10 {padding-bottom:16px; border-bottom: 2px solid #111;}}
            .product_pay {font-size: 16px;}            
        }     
     `}
`;

const ProdDetailSectionNavBlock = styled.p`
    color: #999;
    font-size: 14px;
    margin-bottom: 20px
    ${!isMobileOnly&&`height: 60px;
    line-height: 60px;`};
`;

const ProdDetailTopBlock = styled.div`
    ${!isMobileOnly&&"padding-bottom: 60px"};
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    min-height: 510px;
    ${!isMobileOnly&&"display: flex;"};   
    
    .pd_info-list {
        margin-bottom:0;
        li {
            float:left;
            color: #333;
            ${isMobileOnly?`
             font-size: 12px;
             margin: 10px 0 20px;
            `:`
             font-size: 12px;
             margin-top: 20px;
             margin-bottom: 30px;
            `};
            
        } 
     }
     .calc-percent-block {
         margin-left:10px;
         font-size: 24px;
         font-weight: 500;
         line-height: 1.21;
         color: #ffc742;        
     }
`;

const ProdDetailBottomBlock = styled.div`
    width: 100%;
    // border-top: 1px solid #79b88a;
    // border-bottom: 1px solid #e7e7e7;
    background-color:#fff;
    
    ${isMobileOnly?`
    margin: 0 0 0px 0;
    `:`
    margin: 0 0 160px 0;
    `}

    /*Brand home 상품*/
    // .pd_brand-box {
    // position: relative;
    // ${!isMobileOnly&&`
    //   width: 250px;
    //   margin-right: 15px;
    // `};
    
    .prod-desc {
        ${isMobileOnly ? `float: none` : `float: none`};        
        width: ${isMobileOnly ? "unset" : "unset"};
        margin-bottom: ${isMobileOnly ? "30px" : "100px"};
        padding-right: 0;
        position: relative;
        transition: max-height .3s ease-in;
        
        ${!isMobileOnly&&`
            display: flex;
            flex-direction: column;
            align-items: center;        
        `}
        &.hidden-on-mobile {
            // border-bottom: 1px solid #ccc;
            // max-height:100vh;
            max-height: 505px;
            overflow: hidden;
            transition: max-height .3s ease-out;

            &:before {
                position: absolute;
                right: 0;
                // bottom: 55px;
                bottom:0;
                left: 0;
                z-index: 10;
                // height: 50px;
                height: 155px;
                background-image: linear-gradient(to bottom, rgba(255,255,255,0), #fff);
                content: '';
            }
        }

        max-height: 100%;
        //transition: max-height 0.25s ease-in;
        
    }  

    .brand-intro {
      display:flex;
      justify-content: space-between;
      
      ${isMobileOnly&&`
          .pd_brand-box {
            position: relative;
            line-height: 1.4;
            font-size: 14px;
            min-width: 40vw;    
          }
          .rb-list {
            width: 940px;
            display:flex;
            overflow-x:scroll;
            overflow-y: hidden;
          }
          
      `};
    }

    .etcInfoTable {
        //margin-top:20px;
        ${isMobileOnly?`
            border: 0;        
            tr>td {
                padding:10px 0;
                border:none;
                line-height:1.69;
                &:nth-child(1){color:#999999; font-size:13px; width:35%; }
                &:nth-child(2){color:#333333; font-size:13px;}
            }
            tr:last-of-type {
                td {padding-bottom:0;}
            }        
        `:`
            border: 0;        
            tr>td {
                padding:5px 0;
                border:none;
                &:nth-child(1){color:#999999; font-size:14px; width:180px; padding-left:35px; line-height:1.2}
                &:nth-child(2){color:#333333; font-size:13px; width: 520px; padding-left: 15px; line-height:1.69}
            }
            tr:last-of-type {
                td {padding-bottom:30px; border-bottom:1px solid #ccc;}
            }
            tr:first-of-type {
                td {padding-top:30px;}            
            }        
        `}

    }

    .refund-box {
        ${isMobileOnly?`
            border-top:1px solid #cccccc; 
            h4 {margin:20px 0 10px;} 
            li {line-height: 20px;}
                    
            h4 {font-size:13px; font-weight: 500;}
            .desc {
                font-size: 12px;
                margin: 10px 0;
                line-height: 22px;
            }
             .detail-desc {
             &.bottom {margin-bottom:30px;}
             li{
                font-size: 12px;
                color: #666666;
                line-height: 1.67;
                .comment {color: #cccccc; font-size: 12px }
              }
             }   
            
        `:`
             padding: 0 15px;
            h4 {font-size:13px; font-weight: 500; line-height: 1.69; margin-bottom: 10px;}        
            .desc {
                // margin-top: 15px;
                margin-bottom: 10px;
                font-size: 13px;
                line-height: 1.69;
                font-weight: normal;
                color: #333;
            }
             .detail-desc {
                li{
                    font-size: 12px;
                    color: #666666;
                    .comment {color: #cccccc; font-size: 12px }
                }
              }   
            
        `}
    }

    .recom-pd {
        .title {
            font-size: 18px;
            font-weight: 700;
            line-height: 1.11;
            color: #111111;
        }
    }

    .slick-list {
        margin-left: -14px;
        margin-right: -14px;
    }

    .recom-mobie-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        padding: 0 0 10px 0;

        li:last-child {
            padding-right: 4vw;
        }
        li:first-child {
            margin-left: 4vw;
        }
    }

    .mobile-pd-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        padding: 0 0 10px 0;
        //width: max-content;

        .pd-slider:last-child {
            padding-right: 4vw;
        }
        .pd-slider:first-child {
            margin-left: 4vw;
        }
    }

    iframe {
        width: 100%;
    }
`;

const ProdDetailStickyBlock = styled.div`
    display: ${prods => prods.display || 'none'};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: transparent;
    z-index: 100;
`;

const ProdMenuTitle = styled.span`
    display: block;
    width: 100%;
    padding: ${isMobileOnly?"18px 0":"22px 0"};
    font-size: ${isMobileOnly?"14px":"15px"};
`;

const ProdItemPBlock = styled.p`
    margin-bottom: 20px;    
    min-height: 155px;
    cursor: pointer;
    line-height : 155px;
`;

const ProdListItemImg = styled.img`
    border-radius: 4px;
    min-width: 100%; 
    min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    max-height: 155px;
    max-width : 155px;
    vertical-align : middle;
    object-fit: cover;
`;

const AnchorBlock = styled.div`
    ${isMobileOnly?`
        width: 100vw;
        margin-left: -4vw;   
        margin-bottom: 10px; 
    `:`
        width: 100%;  
        margin-bottom: 40px;
    `}
    border-bottom: 1px solid #e7e7e7;
    border-top: 1px solid #e7e7e7;
    
    background-color: #ffffff;

    .container {
        width: 1176px;
        margin: 0 auto;
    }
    .li-container {
        width: 801px;
    }
    .li-blank {
        width: 375px;
    }
    
    li.active {
        border-bottom: 3px solid #ffc742;
    }

    &.fixed {
        position: fixed;
        top: ${isMobileOnly?"60px":"80px"};
        z-index: ${isMobileOnly?"20":"4"};
        }

`;

const WingBlock = styled.div`
    width: 100%;
    position: relative;
    &.fixed {
        position: fixed;
        top: ${isMobileOnly?"50px":"180px"};
        z-index: 2;
    }
`;

const BrandBlock = styled.div`
    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 100px);
        padding-top: 15px;
    }

    .brand-name {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `:`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        width: calc(100% - 110px);
        `};
    }

    .brand-info {
        ${isMobileOnly?`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `:`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `};
    }

    .brand-home {
        font-size: 14px;
        line-height: 1.57;
        color: #111111;
        top: 6px;
        position: relative;
    }
    
    
`;

const BrandThumBlock = styled.div`
    ${isMobileOnly?`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `:`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const ProdDetailOptionTitleBlock = styled.div`
    width: 340px;
    .option-title {
        line-height: 1.4;
        width: ${isMobileOnly ? "90vw" : "100%"};
        //margin-bottom: 35px;
        margin: ${isMobileOnly?"20px 0 22px":"0"};
        font-size: 24px;
        font-weight: 500;

        h3 { margin-bottom: 20px;}
        .brand-name {
            display: block;
            font-size: ${isMobileOnly?"12px":"14px"};
            color: #999999;
            font-weight: 400;
            ${!isMobileOnly&&`margin-bottom: 20px`};
        }        
    }
`;

const ProdDetailPdTitleBlock = styled.h3`
    line-height: ${isMobileOnly?"24px":"1.33"};
    width: ${isMobileOnly ? "90vw" : "100%"};
    //margin-bottom: 35px;
    font-size: ${isMobileOnly ? "18px" : "24px"};;
    font-weight: 500;
    // ${isMobileOnly && `margin-top:15px`};
`;

const SectionSplitterBlock = styled.div`
    width: ${isMobileOnly?"100vw":"800px"};
    height: ${props=>props.height};
    margin-left: ${isMobileOnly?"-4vw":"-40px"};
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const BtnShowMoreBlock = styled.button`
    font-size: 16px;
    font-weight: 500;
    color: #111;
    //background-color: #ffc742;
    border: 1px solid #111;
    //-webkit-box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    //-moz-box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    //box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    width: ${isMobileOnly?"92vw":"665px"};
    //line-height: normal;
    padding: 14px 0;
    //display: block;
    display: flex;
    align-items: center;
    overflow:hidden;
    position:absolute;
    bottom:0;
    z-index:10;
    background-color:#fff;
    border-radius: 5px;
    justify-content: center;
    img {margin-left:12px;}
`;

const StyleLoader = styled(LoadingOverlay)`
    ${isMobileOnly?`
    width: 100vw;
    margin-left: -4vw;
    `:`
    
    `};
`;

const ProductDetail = ({ location }) => {

    // 상품 정보
    const [prodinfo, setProdInfo] = useState(null);
    const [sticky, setSticky] = useState(false);
    const [activeMenu, setActiveMenu] = useState(0);

    const dispatch = useDispatch();
    const history = useHistory();

    const posRef = useRef([React.createRef(), React.createRef(), React.createRef()]);
    const stickyRef = useRef(null);
    const refBtnShowMore = useRef(null);
    const [showMore, setShowMore] = useState(false);
    const [showMoreText, setShowMoreText] = useState('상품 상세 펼쳐 보기')
    const scrollToBtn = (ref) => window.scrollTo(0, (ref.current.offsetTop - 400), { behaviour: 'smooth' });

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        // variableWidth: true,
        slidesToShow: isMobileOnly? 3:3,  // 1 slide if mobile
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SlideBtn className="left" right={true}/>,
        prevArrow: <SlideBtn className="left"/>
        //swipeToSlide: true
      };

      const settings2 = {
        dots: false,
        infinite: false,
        speed: 500,
        // variableWidth: true,
        slidesToShow: isMobileOnly? 3:3,  // 1 slide if mobile
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SlideBtn className="left" right={true} top="38%"/>,
        prevArrow: <SlideBtn className="left" top="38%"/>
        //swipeToSlide: true
      };

    const { loading, proddata, locinfo, accessToken, id, esProdItems } = useSelector(
        ({ loadingReducer, prodDetailReducer, userReducer,esItemsReducer }) => ({
            loading: loadingReducer['user/DETAIL'],
            proddata: prodDetailReducer.proddata,
            locinfo: prodDetailReducer.locinfo,
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            esProdItems: esItemsReducer.esProdItems,
        })
    );

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //상품 좋아요/ 상품 요청 데이터 획득
    useEffect(() => {

        if (accessToken !== null) {
            dispatch(prodAction(id));
            dispatch(brandAction(id));
        }
        else {
            dispatch(setClipProdIdAction(null));
            dispatch(setClipBrandIdAction(null));
        }
    }, [accessToken]);

    const onScroll = () => {

        try {
            let posProductY = posRef.current[0].current.getBoundingClientRect().y;
            let posDeliveryY = posRef.current[1].current.getBoundingClientRect().y;
            let posRefuntY = posRef.current[2].current.getBoundingClientRect().y;
            let marginTop = 500;

            if(isMobileOnly) {
                marginTop = 180;
            }

            if (posProductY < marginTop && posDeliveryY > marginTop) {
                setActiveMenu(1);
            } else if (posDeliveryY < marginTop && posRefuntY > marginTop) {
                setActiveMenu(2);
            } else if (posRefuntY < marginTop) {
                setActiveMenu(3);
            }
            else {
                setActiveMenu(1);
            }
        } catch (e) {
            // console.log("error : " + JSON.stringify(e));
        }

    };

    useEffect(() => {
        // 최초 실행시 처리
        dispatch(setCurMenuAction('pd'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);

        // console.log(location.search);
        // 조회 Query State가 없으면 404 Error
        if (location.search === null || location.search === undefined) {
            history.push("/notfound");
        } else {
            if (location.search !== locinfo) {
                dispatch(detailAction(location.search));
                dispatch(setLocInfo(location.search));
                dispatch(reqEsProdAction());
                setShowMore(false);
            } else if (proddata !== null && proddata !== undefined) {
                try {
                    // 썸네일 이미지 만들기
                    let thumbnailimg = [];
                    thumbnailimg.push(proddata._source.repr_img);
                    thumbnailimg.push(proddata._source.opt_img_1);
                    thumbnailimg.push(proddata._source.opt_img_2);
                    thumbnailimg.push(proddata._source.opt_img_3);
                    thumbnailimg.push(proddata._source.opt_img_4);
                    thumbnailimg.push(proddata._source.opt_img_5);
                    thumbnailimg.push(proddata._source.opt_img_6);
                    thumbnailimg.push(proddata._source.opt_img_7);
                    thumbnailimg.push(proddata._source.opt_img_8);
                    thumbnailimg.push(proddata._source.opt_img_9);
                    proddata._source.thumbnails = thumbnailimg.filter(isNull);
                    proddata._source.prdct_detail2 = fixContents(proddata._source.prtnr_id, proddata._source.prdct_detail)
                    dispatch(setSelProdInfoAction(proddata._source));
                    setProdInfo(proddata._source);
                } catch (e) {
                    history.push("/notfound");
                }

            }
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);

    }, [proddata, location])

    useEffect(() => {
        if (!posRef.current[0].current) return;
        setShowMoreText(showMore ? '상품 상세 접기' : '상품 상세 펼쳐 보기');
        // isMobileOnly && showMore ? posRef.current[0].current.classList.remove('hidden-on-mobile') : posRef.current[0].current.classList.add('hidden-on-mobile');
        showMore ? posRef.current[0].current.classList.remove('hidden-on-mobile') : posRef.current[0].current.classList.add('hidden-on-mobile');
        // if (isMobileOnly) {
            !!showMore ? posRef.current[0].current.classList.remove('hidden-on-mobile') : posRef.current[0].current.classList.add('hidden-on-mobile');
            if (!showMore) window.setTimeout(() => { scrollToBtn(refBtnShowMore) }, 500)
        // }

    }, [showMore])

    const onClickShowMore = () => {
        setShowMore(!showMore);
    }

    const fixContents = (bid, contents) =>{
        // 기존 고도몰 호스팅에서 이미지 강제로 가져오기 checkGodomol,
        // https 업그레이드가 안된 http 호스트에 대해 (에타) 리버스프록시로 https를 강제로 거치도록 하는 기능 추가함
        // console.log(bid,contents.replaceAll('<img', '<img referrerpolicy="no-referrer"'))
        const bids_godo = ['cenare'];     // 고도몰은 다른 사이트에서 이미지 빨아가는걸 싫어함
        const bids_http = ['etahcompany', 'mobel']         // 에타는 SSL적용에 난항을 겪고 있는듯

        //return bids.find(o=>o===bid)?contents.replaceAll('<img', '<img referrerpolicy="no-referrer"'):contents;
        let rtn = contents;
        if(bids_godo.find(o=>o===bid)){
            rtn = contents.replace(/<img/g, '<img referrerpolicy="no-referrer"')
        } else if (bids_http.find(o=>o===bid)){
            rtn = contents.replace(/(<[ ]*?img.*? src=['|"])(http:\/\/.*?)(['|"])/gm, "$1https://partner.odgagu.co.kr/external?url=$2$3");

            /* etah의 경우는 wrapper style이 별도로 존재함. 이후에도 이런케이스가 생길때는 조건들(bids_http)을 objet array 로 하는 등의 구조변경을 고민해야 함 TODO*/
            /* 현재 function은 rendering전 실행되므로 DOM구조를 못찾음. 해결책으로 setTimeout이 결코 좋은 practice는 아니지만,
               코드가 지저분해질것 같아 한곳에서 처리하기 위해 사용함. 더 좋은 방법을 고민해야 함. TODO */
            window.setTimeout(()=>{posRef.current[0].current.setAttribute("style",isMobileOnly?"width:92vw;":"width:830px; margin:0 auto;")},500)
        }
        return rtn;
    }
    const isNull = (value) => {
        return value !== null;
    }

    // 배송 불가 지역
    const getNodeDlvryArea = () => {
        let noneArea = '';

        // console.log("prodinfo : " + JSON.stringify(prodinfo));

        // 배송 불가 지역 없는 경우
        if (prodinfo.non_dlvry_area0) {
            return "없음";
        }

        // 제주 배송 불가 지역
        if (prodinfo.non_dlvry_area1) {
            noneArea += "제주";
        }

        // 도서 산간 지역
        if (prodinfo.non_dlvry_area2) {
            if (noneArea.length > 0) {
                noneArea += " / ";
            }

            noneArea += "도서산간지역";
        }

        // 배송불가 지역 기타
        if (prodinfo.non_dlvry_area3) {
            if (noneArea.length > 0) {
                noneArea += " / ";
            }

            noneArea += prodinfo.non_dlvry_extra;
        }

        return noneArea;
    }

    // 배송비
    const getQuantityPaid = () => {
        if (prodinfo.is_quantity_paid) {
            return "주문 상품 개수에 비례하여 배송비 부과";
        } else {
            return "없음"
        }
    }

    const onReqClose = () => {
        // console.log("onReqClose +++++");
    }

    if (prodinfo === null) {
        return <ProdDetailBlock />;
    }
    const handleMenuClick = (param) => {
        /* let targetY = posRef.current[param - 1].current.getBoundingClientRect().y;
        let margin = window.scrollY + targetY;

        if (stickyRef.current.getBoundingClientRect().height < 300) {
            window.scrollTo(0, margin - 250);
        } else {
            window.scrollTo(0, margin - 450);
        } */


        let targetY = posRef.current[param - 1].current.getBoundingClientRect().y;

        let margin = window.scrollY + targetY;

        window.scrollTo(0,margin-((param===1?130:170)));

    }

    const getCateName = (cate_name) => {

        if (cate_name !== null) {
            let catenames = split(cate_name, '>');
            return <span>{catenames[0]} <span style={{ marginRight: '10px', marginLeft: '10px' }}>&gt;</span> <span style={{color: '#666666'}}>{catenames[1]}</span></span>

        }

        return "";
    }

    const getProdImageList = (prodinfo) =>{
        return prodinfo.thumbnails.map(o=>({title:"", img:o}))
    }

    const calcDiscount = (prodinfo.prdct_price > prodinfo.sale_price)? `${Math.round(((prodinfo.prdct_price-prodinfo.sale_price)/prodinfo.prdct_price)*100)}%`:""

    const checkAnchorPosition = (props=>{
        if(props.currentPosition === "above"){
            setSticky(true);
        } else {
            setSticky(false);
        }
    })

    const handleProdClick = (prodinfo) => {
        //console.log("prod = " + JSON.stringify(prodinfo))
        history.push('/prod?prodid=' + prodinfo.prdct_id)
    }

    const handleImgClick = (id) => {
        history.push('/prod?prodid=' + id);
    }

    const microdata = () => <Helmet>
        <meta property="product:brand" content={prodinfo.brand[0].brnd_han} />
        <meta property="product:availability" content="in stock" />
        <meta property="product:condition" content="new" />
        <meta property="product:price:amount" content={prodinfo.sale_price} />
        <meta property="product:price:currency" content="KRW" />
        <meta property="product:retailer_item_id" content={prodinfo.prdct_id} />
    </Helmet>

    return (
        isMobileOnly?
        <ProdDetailBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                {microdata()}
                <Header />
                <ProdDetailContainerBlock>
                    <ProdDetailTopBlock>
                        {/*<ProdThumbnail imglist={prodinfo.thumbnails} />*/}
                        <SlideBanner slideItemsInfo={getProdImageList(prodinfo)} pWidth="360px" pHeight="360px" pMargin="0 20px 0 0" mHeight="100vw" mWidth="100vw" mMargin="0 0 0 -4vw" autoPlay={true} showControl={false} />
                        <ProdDetailOptionTitleBlock>

                            <ProdDetailOption prodinfo={prodinfo} onReqClose={onReqClose} />
                            <ProdDetailOption2 prodinfo={prodinfo} onReqClose={onReqClose} />

                        </ProdDetailOptionTitleBlock>
                    </ProdDetailTopBlock>

                </ProdDetailContainerBlock>
                <SectionSplitterBlock height="8px"/>
                <Waypoint topOffset="50px" onPositionChange={(props)=>checkAnchorPosition(props)} fireOnRapidScroll/>
                <AnchorBlock className={sticky?"fixed":""}>
                    <button type="button" className="pd_top_close-btn"></button>
                    <ul className="p-detail-list sz-wrap clearfix">
                        <li className={activeMenu === 1 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(1) }}>상세정보</ProdMenuTitle>
                        </li>
                        <li className={activeMenu === 2 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(2) }}>배송안내</ProdMenuTitle>
                        </li>
                        <li className={activeMenu === 3 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(3) }}>반품/교환/AS</ProdMenuTitle>
                        </li>
                    </ul>
                </AnchorBlock>

                <AnchorBlock style={{display:sticky?'block':'none'}}>
                      <div style={{height:'50px'}}>

                      </div>
                </AnchorBlock>

                <ProdDetailBottomContainerBlock>
                    <ProdDetailBottomBlock >

                        <div className="sz-wrap">
                            <div id="productInfoSection" className="prod-desc hidden-on-mobile" ref={posRef.current[0]}>
                                {/* <--for danielwood, badafurniture 임시-->*/}
                                {proddata._source.prtnr_id === 'danielwood'?<div style={{textAlign: 'center'}}><img referrerpolicy="no-referrer" src="https://shop.odgagu.co.kr/data/commonimg/odgagu/seller_notice/210823_210930-danielwood-notice.jpg" /></div>:'' }
                                {proddata._source.prtnr_id === 'badafurniture'?<div style={{textAlign: 'center'}}><img referrerpolicy="no-referrer" src="https://shop.odgagu.co.kr/data/commonimg/odgagu/seller_notice/210827_kbada-notice.png" /></div>:'' }
                                <div dangerouslySetInnerHTML={{ __html: prodinfo.prdct_detail2 }}
                                    style={{ paddingBottom: 0, textAlign: 'center' }}></div>
                                <ProdSpecs specLabels={prodinfo.spec_labels} specValues={prodinfo.prd_spec}/>
                                <BtnShowMoreBlock ref={refBtnShowMore} className="show-more" onClick={() => onClickShowMore()}>{showMoreText} {showMore?<img src="/assets/images/icon/show-less.svg"/>:<img alt={showMoreText+'버튼화살표'} src="/assets/images/icon/show-more.svg"/>}</BtnShowMoreBlock>
                            </div>
                            <SectionSplitterBlock height="8px" style={{marginTop:"40px", marginBottom: "30px"}}/>
                            <BrandBlock className="clearfix margin_b-30">
                                <div className="clearfix margin_b-20">
                                    <div className="container-left">
                                        <Link to={"/brHome/" + prodinfo.brnd_id}>
                                        <BrandThumBlock backgroundimage={prodinfo.brand[0].brnd_thumb_url.replace(/ /g, "%20")} />
                                        </Link>
                                    </div>
                                    <div className="container-right">
                                        <div className="clearfix">
                                            <div className="f-left brand-name">
                                            <Link to={"/brHome/" + prodinfo.brnd_id}>
                                                            {prodinfo.brand[0].brnd_han}
                                                            </Link>
                                            </div>
                                        </div>
                                        <div >
                                            <div className="brand-info">
                                            {prodinfo.brand[0].brnd_info_brief}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{width:'100vw', marginLeft:'-4vw'}}>
                                    {
                                        prodinfo.prods === null ? '' :
                                        <div className="mobile-pd-conatiner">
                                            {
                                            prodinfo.prods.map((curprod) => {
                                                return (
                                                    <ProdItemSlider key={curprod.prdct_id}
                                                        img={curprod.repr_img}
                                                        prodname={curprod.prdct_nm}
                                                        sale_price={curprod.sale_price}
                                                        prdct_price={curprod.prdct_price}
                                                        brandname={curprod.brnd_han}
                                                        isBrandShow={false}
                                                        clickHandler={handleProdClick}
                                                        brandid={curprod.brnd_id}
                                                        prdct_id={curprod.prdct_id}
                                                        prodinfo={curprod} />
                                                )
                                            })
                                        }
                                        </div>

                                    }

                                </div>

                            </BrandBlock>

                            <SectionSplitterBlock height="8px"/>
                            <div id="deliveryInfoSection" className="default-table margin_b-30 margin_t-30" ref={posRef.current[1]}>
                                <h3 className="dt-title pad-b10">배송안내</h3>
                                {/*<div className="horizontal-separator" />*/}
                                <table className="etcInfoTable">
                                    <tbody>
                                        <tr>
                                            <td>배송유형</td>
                                            <td>{prodinfo.dlvry_method_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>배송 불가 지역</td>
                                            <td>{getNodeDlvryArea(prodinfo)}</td>
                                        </tr>
                                        <tr>
                                            <td>배송비 지불 방식</td>
                                            <td> {prodinfo.dlvry_pay_type_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>지역별 차등 배송비</td>
                                            <td>{!!prodinfo.is_dlvry_ref?'상품상세 참조':prodinfo.dlvry_fee_extra}</td>
                                        </tr>
                                        <tr>
                                            <td>배송 예정일자 </td>
                                            <td>{prodinfo.dlvry_period_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>비례 배송비</td>
                                            <td>{getQuantityPaid(prodinfo)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <SectionSplitterBlock height="8px"/>
                            <div id="refundInfoSetion" className="default-table margin_b-30 margin_t-30" ref={posRef.current[2]}>
                                <h3 className="dt-title pad-b10">반품/교환/AS</h3>
                                {/*<div className="horizontal-separator" />*/}
                                <table className="etcInfoTable margin_b-20">
                                    <tbody>
                                        <tr>
                                            <td>반품 배송비</td>
                                            <td>
                                                <span className="font-mont"> 상품 상세 참조 </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>보내실 곳</td>
                                            <td>{prodinfo.rtrn_zip} ) &nbsp; {prodinfo.rtrn_addr1}&nbsp;{prodinfo.rtrn_addr2}</td>
                                        </tr>
                                        <tr>
                                            <td>교환 배송비</td>
                                            <td>
                                                <span className="font-mont"> 상품 상세 참조 </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="refund-box">
                                    <h4>
                                        * 반품/교환 사유로 요청 가능 기간
                                    </h4>
                                    <div className="desc">
                                        반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                                    </div>
                                    <ol className="detail-desc">
                                        <li>
                                            1. 구매자 단순 변심은 상품 수령 후 7일 이내 {isMobileOnly?<div
                                        className="comment">(구매자 반품배송비 부담)</div>:<span
                                        className="comment">(구매자 반품배송비 부담)</span>}
                                        </li>
                                        <li>
                                            2. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. {!isMobileOnly&&<><br/> &nbsp;&nbsp;</>}둘 중 하나 경과 시 반품/교환 불가
                                            {isMobileOnly?<div className="comment">(판매자 반품배송비 부담)</div>:<span className="comment">(판매자 반품배송비 부담)</span>}
                                        </li>
                                    </ol>

                                    <h4>
                                        * 반품/교환 불가능한 사유<br></br>

                                    </h4>
                                    <div className="desc">
                                        아래와 같은 경우 반품/교환이 불가능합니다.
                                    </div>
                                    <ol className="detail-desc bottom">
                                        <li>1. 반품요청기간이 지난 경우</li>
                                        <li>2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우
                                            {isMobileOnly?<div className="comment">(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</div>:<span className="comment">(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</span>}
                                        </li>
                                        <li>3. 포장을 개봉하였으나 포장이 훼손되어 상품가치가 현저히 상실된 경우
                                            {isMobileOnly?<div className="comment">(예: 식품, 화장품)</div>:<span className="comment">(예: 식품, 화장품)</span>}
                                        </li>
                                        <li>4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우
                                            {isMobileOnly?<div className="comment">(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</div>:<span className="comment">(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</span>}
                                        </li>
                                        <li>5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
                                            {isMobileOnly?<div className="comment"> (예: 식품, 화장품)</div>:<span className="comment"> (예: 식품, 화장품)</span>}
                                        </li>
                                        <li>6. 고객주문 확인 후 상품제작에 들어가는 주문제작상품</li>
                                        <li>7. 복제가 가능한 상품 등의 포장을 훼손한 경우
                                            {isMobileOnly?<div className="comment">(CD/DVD/GAME/도서의 경우 포장 개봉 시)</div>:<span className="comment">(CD/DVD/GAME/도서의 경우 포장 개봉 시)</span>}
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            {
                                esProdItems&&esProdItems.length>0?
                                <div className="recom-pd">
                                    <SectionSplitterBlock height="8px"/>
                                    <div id="recommendSection" className="default-table margin_b-60 margin_t-30" >
                                        <h3 className="dt-title pad-b10 margin_b-10">추천 아이템</h3>
                                        <div style={{width:'100vw', marginLeft:'-4vw'}}>

                                                <div className="mobile-pd-conatiner">
                                                    {
                                                    esProdItems.map((curprod) => {
                                                        return (
                                                            <ProdItemSlider key={curprod.prdct_id}
                                                                img={curprod.repr_img}
                                                                prodname={curprod.prdct_nm}
                                                                sale_price={curprod.sale_price}
                                                                prdct_price={curprod.prdct_price}
                                                                brandname={curprod.brnd_han}
                                                                isBrandShow={true}
                                                                clickHandler={handleProdClick}
                                                                brandid={curprod.brnd_id}
                                                                prdct_id={curprod.prdct_id}
                                                                prodinfo={curprod} />
                                                        )
                                                    })
                                                }
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            :''
                            }
                        </div>
                    </ProdDetailBottomBlock>

                </ProdDetailBottomContainerBlock>
                <div style={{width: '100vw', marginLeft: '-4vw' }}>
                <Footer siteMovePosition="110px"/>
                </div>

            </LoadingOverlay>
        </ProdDetailBlock>
        :
        <ProdDetailBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                {microdata()}
                <Header />
                {/* <ProdDetailStickyBlock display={sticky ? 'block' : 'none'} ref={stickyRef}>
                    <ProdDetailStickyOption prodinfo={prodinfo}
                        onReqClose={onReqClose}
                        activeMenu={activeMenu}
                        onClickMenu={handleMenuClick} />
                </ProdDetailStickyBlock> */}

                <ProdDetailContainerBlock>
                    <ProdDetailSectionNavBlock>
                        <span>{getCateName(prodinfo.cate_fullname)}{/* prodinfo.cate_fullname */}</span>
                    </ProdDetailSectionNavBlock>


                    <ProdDetailTopBlock>
                        <ProdThumbnail imglist={prodinfo.thumbnails} />
                        <ProdDetailOption prodinfo={prodinfo} onReqClose={onReqClose} />
                    </ProdDetailTopBlock>

                </ProdDetailContainerBlock>

                <Waypoint topOffset="80px" onPositionChange={(props)=>checkAnchorPosition(props)} fireOnRapidScroll/>
                  <AnchorBlock className={sticky?"fixed":""}>
                      <div className="container clearfix">
                      <div className="f-left li-container">
                        <ul className="p-detail-list sz-wrap clearfix">
                            <li className={activeMenu === 1 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                                <ProdMenuTitle onClick={() => { handleMenuClick(1) }}>상세정보</ProdMenuTitle>
                            </li>
                            <li className={activeMenu === 2 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                                <ProdMenuTitle onClick={() => { handleMenuClick(2) }}>배송안내</ProdMenuTitle>
                            </li>
                            <li className={activeMenu === 3 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                                <ProdMenuTitle onClick={() => { handleMenuClick(3) }}>반품/교환/AS</ProdMenuTitle>
                            </li>
                        </ul>
                      </div>
                      <div className="li-blank f-left">

                      </div>
                      </div>
                </AnchorBlock>

                <AnchorBlock style={{display:sticky?'block':'none'}}>
                      <div style={{height:'60px'}}>

                      </div>
                </AnchorBlock>

                {/* <div className="pd_list-wrap margin_b-50">
                    <button type="button" className="pd_top_close-btn"></button>
                    <ul className="p-detail-list sz-wrap clearfix">
                        <li className={activeMenu === 1 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(1) }}>상세정보</ProdMenuTitle>
                        </li>
                        <li className={activeMenu === 2 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(2) }}>배송안내</ProdMenuTitle>
                        </li>
                        <li className={activeMenu === 3 ? 'active' : ''} style={{ cursor: 'pointer' }}>
                            <ProdMenuTitle onClick={() => { handleMenuClick(3) }}>반품/교환/AS</ProdMenuTitle>
                        </li>
                    </ul>
                </div> */}

                <ProdDetailBottomContainerBlock className="clearfix">
                    <div className="left-container f-left">
                        <ProdDetailBottomBlock >

                        <div className="sz-wrap">
                            <div id="productInfoSection" ref={posRef.current[0]}>
                                {/* <--for danielwood, badafurniture 임시-->*/}
                                {proddata._source.prtnr_id === 'danielwood'?<div style={{textAlign: 'center'}}><img referrerpolicy="no-referrer" src="https://shop.odgagu.co.kr/data/commonimg/odgagu/seller_notice/210823_210930-danielwood-notice.jpg" /></div>:'' }
                                {proddata._source.prtnr_id === 'badafurniture'?<div style={{textAlign: 'center'}}><img referrerpolicy="no-referrer" src="https://shop.odgagu.co.kr/data/commonimg/odgagu/seller_notice/210827_kbada-notice.png" /></div>:'' }
                                <div dangerouslySetInnerHTML={{ __html: prodinfo.prdct_detail2 }}
                                    style={{ marginBottom: '50px', textAlign: 'center' }}></div>
                            </div>
                            <ProdSpecs specLabels={prodinfo.spec_labels} specValues={prodinfo.prd_spec}/>
                            <BrandBlock className="clearfix margin_b-60">
                                <div className="clearfix margin_b-20">
                                    <div className="container-left">
                                        <BrandThumBlock backgroundimage={prodinfo.brand[0].brnd_thumb_url.replace(/ /g, "%20")} />
                                    </div>
                                    <div className="container-right">
                                        <div className="clearfix">
                                            <div className="f-left brand-name">
                                                            {prodinfo.brand[0].brnd_han}
                                            </div>
                                            <div className="f-right brand-home underline">
                                            <Link to={"/brHome/" + prodinfo.brnd_id}>
                                                BRAND HOME
                                                </Link>
                                            </div>
                                        </div>
                                        <div >
                                            <div className="brand-info">
                                            {prodinfo.brand[0].brnd_info_brief}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div >
                                    {
                                            prodinfo.prods === null ? '' :
                                            <Slider {...settings2} >
                                            {
                                                prodinfo.prods.map((curprod) => {
                                                    return (
                                                        <ProdItemSlider key={curprod.prdct_id}
                                                            img={curprod.repr_img}
                                                            prodname={curprod.prdct_nm}
                                                            sale_price={curprod.sale_price}
                                                            prdct_price={curprod.prdct_price}
                                                            brandname={curprod.brnd_han}
                                                            isBrandShow={false}
                                                            clickHandler={handleProdClick}
                                                            brandid={curprod.brnd_id}
                                                            prdct_id={curprod.prdct_id}
                                                            prodinfo={curprod} />
                                                    )
                                                })
                                            }
                                            </Slider>
                                    }

                                </div>

                            </BrandBlock>

                            <div id="deliveryInfoSection" className="default-table margin_b-60" ref={posRef.current[1]}>
                                <h3 className="dt-title pad-b10">배송안내</h3>
                                <table className="etcInfoTable">
                                    <tbody>
                                        <tr>
                                            <td>배송유형</td>
                                            <td>{prodinfo.dlvry_method_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>배송 불가 지역</td>
                                            <td>{getNodeDlvryArea(prodinfo)}</td>
                                        </tr>
                                        <tr>
                                            <td>배송비 지불 방식</td>
                                            <td> {prodinfo.dlvry_pay_type_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>지역별 차등 배송비</td>
                                            <td>{!!prodinfo.is_dlvry_ref?'상품상세 참조':prodinfo.dlvry_fee_extra}</td>
                                        </tr>
                                        <tr>
                                            <td>배송 예정일자 </td>
                                            <td>{prodinfo.dlvry_period_txt}</td>
                                        </tr>
                                        <tr>
                                            <td>비례 배송비</td>
                                            <td>{getQuantityPaid(prodinfo)}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                            <div id="refundInfoSetion" className="default-table margin_b-60" ref={posRef.current[2]}>
                                <h3 className="dt-title pad-b10">반품/교환/AS</h3>
                                <table className="etcInfoTable margin_b-20">
                                    <tbody>
                                        <tr>
                                            <td>반품 배송비</td>
                                            <td>
                                                <span className="font-mont"> 상품 상세 참조 </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>보내실 곳</td>
                                            <td>{prodinfo.rtrn_zip} ) &nbsp; {prodinfo.rtrn_addr1}&nbsp;{prodinfo.rtrn_addr2}</td>
                                        </tr>
                                        <tr>
                                            <td>교환 배송비</td>
                                            <td>
                                                <span className="font-mont"> 상품 상세 참조 </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="refund-box">
                                    <h4>
                                        * 반품/교환 사유로 요청 가능 기간
                                    </h4>
                                    <div className="desc">
                                        반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                                    </div>
                                    <ol className="detail-desc">
                                        <li>
                                            1. 구매자 단순 변심은 상품 수령 후 7일 이내 {isMobileOnly?<div
                                          className="comment">(구매자 반품배송비 부담)</div>:<span
                                          className="comment">(구매자 반품배송비 부담)</span>}
                                        </li>
                                        <li>
                                            2. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. 둘 중 하나 경과 시 반품/교환 불가
                                            {isMobileOnly?<div className="comment">(판매자 반품배송비 부담)</div>:<span className="comment">(판매자 반품배송비 부담)</span>}
                                        </li>
                                    </ol>

                                    <h4>
                                        * 반품/교환 불가능한 사유<br></br>

                                    </h4>
                                    <div className="desc">
                                        아래와 같은 경우 반품/교환이 불가능합니다.
                                    </div>
                                    <ol className="detail-desc bottom">
                                        <li>1. 반품요청기간이 지난 경우</li>
                                        <li>2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우
                                            {isMobileOnly?<div className="comment">(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</div>:<span className="comment">(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</span>}
                                        </li>
                                        <li>3. 포장을 개봉하였으나 포장이 훼손되어 상품가치가 현저히 상실된 경우
                                            {isMobileOnly?<div className="comment">(예: 식품, 화장품)</div>:<span className="comment">(예: 식품, 화장품)</span>}
                                        </li>
                                        <li>4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우
                                            {isMobileOnly?<div className="comment">(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</div>:<span className="comment">(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</span>}
                                        </li>
                                        <li>5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
                                            {isMobileOnly?<div className="comment"> (예: 식품, 화장품)</div>:<span className="comment"> (예: 식품, 화장품)</span>}
                                        </li>
                                        <li>6. 고객주문 확인 후 상품제작에 들어가는 주문제작상품</li>
                                        <li>7. 복제가 가능한 상품 등의 포장을 훼손한 경우
                                            {isMobileOnly?<div className="comment">(CD/DVD/GAME/도서의 경우 포장 개봉 시)</div>:<span className="comment">(CD/DVD/GAME/도서의 경우 포장 개봉 시)</span>}
                                        </li>
                                    </ol>
                                </div>
                            </div>

                            {
                                esProdItems&&esProdItems.length>0?
                                <div className="recom-pd">
                                    <div className="title margin_b-20">추천 아이템</div>
                                        <Slider {...settings} >
                                            {
                                                esProdItems.map((curprod) => {
                                                    return (
                                                        <ProdItemSlider key={curprod.prdct_id}
                                                            img={curprod.repr_img}
                                                            prodname={curprod.prdct_nm}
                                                            sale_price={curprod.sale_price}
                                                            prdct_price={curprod.prdct_price}
                                                            brandname={curprod.brnd_han}
                                                            isBrandShow={true}
                                                            clickHandler={handleProdClick}
                                                            brandid={curprod.brnd_id}
                                                            prdct_id={curprod.prdct_id}
                                                            prodinfo={curprod} />
                                                    )
                                                })
                                            }
                                        </Slider>
                                </div>
                            :''
                            }


                        </div>
                        </ProdDetailBottomBlock>
                    </div>
                    <div className="right-container f-left">
                        <WingBlock  className={sticky&&windowSize.width>700?"fixed":""}>
                            <ProdDetailOptionWing prodinfo={prodinfo} onReqClose={onReqClose} />
                        </WingBlock>
                    </div>

                </ProdDetailBottomContainerBlock>
                <Footer />
            </LoadingOverlay>
        </ProdDetailBlock>
    );
};

export default ProductDetail;
